"use strict";

exports.__esModule = true;
// @flow

var TextElement /*: string | React$ComponentType<*>*/ = 'span';
exports.TextElement = TextElement;